// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__dF_pP","inputWrap":"styles_inputWrap__3-tDX","input":"styles_input__3F-Sz"};